module.exports = __webpack_public_path__ + "static/media/minoan_text_01.28bc6d79.jpg";